module.exports = __webpack_public_path__ + "static/media/dormitorio-3.726e6aec.jpg";